export const LANG_RUS = 'rus'
export const LANG_UKR = 'ukr'
export const LANG_ENG = 'eng'

export const CURRENCY_UKR = 'grn'
export const CURRENCY_RUS = 'grn'
export const CURRENCY_ENG = 'euro'